<template>
    <div class="dispatch-sites">
        <!-- Selection method toggle -->
        <!-- <div class="content-block mode-row">
            <div class="mode-toggle">
                <button class="mode-btn" :class="{ active: mode === 'grid' }" @click="mode = 'grid'">
                    <span class="dx-icon dx-icon-detailslayout"></span> Grid
                </button>
                <button class="mode-btn" :class="{ active: mode === 'map' }" @click="mode = 'map'">
                    <span class="dx-icon dx-icon-map"></span> Map
                </button>
            </div>
            <div class="count-badge">{{ selectedCount }} selected</div>
        </div> -->

        <DispatchSitesGrid v-if="mode === 'grid'" />
        <DispatchSitesMap v-else />

        <div class="nav-row">
            <DxButton icon="chevronleft" text="Previous" styling-mode="outlined" @click="onPrevious" />
            <DxButton icon="chevronright" text="Next" type="default" styling-mode="contained"
                @click="onNext" />
        </div>
    </div>
</template>

<script>
import { DxButton } from 'devextreme-vue/button';
import DispatchSitesGrid from './dispatch-sites-grid.vue';
import DispatchSitesMap from './dispatch-sites-map.vue';

export default {
    name: 'DispatchSites',
    components: {
        DxButton,
        DispatchSitesGrid,
        DispatchSitesMap,
    },
    emits: ['previous', 'next'],
    data() {
        return {
            mode: '!grid',
        };
    },
    computed: {
        // The child components keep the store selection in sync, so the count is
        // read straight from the store and stays correct across mode switches.
        selectedCount() {
            return (this.$store.getters['dispatch/getCurrentDispatchSites'] || []).length;
        },
    },
    methods: {
        onPrevious() {
            this.$emit('previous');
        },
        onNext() {
            this.$emit('next');
        },
    },
};
</script>

<style scoped>
/* Fill the vertical space below the builder title/stepper, down to the nav row.
   The offset accounts for the app header + the builder's title and stepper. */
.dispatch-sites {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 210px);
    min-height: 440px;
}

/* The active picker (map/grid) grows to fill; the nav buttons stay pinned below. */
.dispatch-sites-map,
.dispatch-sites-grid {
    flex: 1;
    min-height: 0;
}

.header-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

h3 {
    margin: 0;
}

.muted {
    color: rgba(150, 150, 150, 0.9);
    font-size: 13px;
    margin: 4px 0 0 0;
}

.count-badge {
    background: rgba(255, 115, 0, 0.15);
    color: rgb(255, 140, 40);
    padding: 6px 14px;
    border-radius: 14px;
    font-size: 13px;
    white-space: nowrap;
}

.mode-row {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
    margin-bottom: 8px;
}

.mode-toggle {
    display: flex;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(255, 115, 0, 0.5);
    flex-shrink: 0;
}

.mode-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 18px;
    font-size: 14px;
    cursor: pointer;
    border: none;
    background: transparent;
    color: inherit;
}

.mode-btn.active {
    background: rgb(255, 115, 0);
    color: #fff;
}

.mode-hint {
    font-size: 12px;
    color: rgba(150, 150, 150, 0.9);
    margin: 0;
}

.nav-row {
    display: flex;
    justify-content: space-between;
    margin: 20px;
    flex-shrink: 0;
}

@media (max-width: 640px) {
    .dispatch-sites {
        height: auto;
    }
}
</style>
